import { TouchPointHelper } from '../../../helpers/touchPointHelper';
import { placeholders, displayGroups } from '@ui';

export const serviceError = {
	prismName: 'serviceError',
	template: {
		templateName: 'ServiceErrorTemplate',
		displayGroups: [
			TouchPointHelper.createDisplayGroup(
				displayGroups.pageContainer,
				[
					TouchPointHelper.createDisplayGroup(
						displayGroups.columnContainer,
						[],
						[
							TouchPointHelper.createPlaceholder(placeholders.serviceError, {
								placeholderBuildReference: 1,
							}),
						]
					),
				],
				[]
			),
		],
	},
};
